import { render, staticRenderFns } from "./cover-designs.vue?vue&type=template&id=097ebb04&scoped=true"
import script from "./cover-designs.vue?vue&type=script&lang=js"
export * from "./cover-designs.vue?vue&type=script&lang=js"
import style0 from "./cover-designs.vue?vue&type=style&index=0&id=097ebb04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097ebb04",
  null
  
)

export default component.exports